
import { SubscriptionPlans as PlanCards } from "./token-management/SubscriptionPlans";

export const SubscriptionPlans = () => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold tracking-tight">Subscription Plans</h2>
        <p className="text-muted-foreground">
          Manage your subscription and choose the plan that best fits your needs
        </p>
      </div>

      <PlanCards />
    </div>
  );
};
